/*
 *
 * LanguageProvider
 *
 * this component connects the redux state language locale to the
 * IntlProvider component and i18n messages (loaded from `app/translations`)
 */

import React from 'react';
import PropTypes from 'prop-types';
import { IntlProvider } from 'react-intl';
import { ConfigProvider } from 'antd';

import { DEFAULT_LOCALE } from '../../../i18n';
import enGB from 'antd/locale/en_GB';

const LanguageProvider = ({ localesData, children }) => {
    const locale = DEFAULT_LOCALE;
    return (
        <IntlProvider locale={locale} key={locale} messages={localesData[locale].messages} textComponent="span">
            <ConfigProvider locale={enGB}>{React.Children.only(children)}</ConfigProvider>
        </IntlProvider>
    );
};

LanguageProvider.propTypes = {
    localesData: PropTypes.object.isRequired,
};

export default LanguageProvider;
